import {
  anyCountry,
  Country,
  foreignCountryEU,
  foreignCountryNonEU,
} from "~/mydata/countries";
import {
  ClassificationCategory,
  ClassificationType,
  E3_561_001,
  E3_561_002,
  E3_561_007,
  E3_562,
  E3_563,
  E3_564,
  E3_565,
  E3_566, E3_567,
  E3_568,
  E3_570,
  E3_880_001, E3_881_001, E3_881_003, E3_881_004, incomeThirdParty,
  InvoiceType as InvoiceTypeMyData,
  otherIncome,
  saleOfAsset,
  saleOfMerchandise,
  saleOfProducts,
  saleOfServices
} from "~/mydata";
import { expectAssignable } from "~/mydata/typeutils";
import { ReadonlyDeep } from "type-fest";

/** 1.1 Τιμολόγιο Πώλησης */
export const salesInvoice = "sales_invoice" as const;
/** 1.1 Τιμολόγιο Πώλησης / Αυτοτιμολόγηση */
export const salesInvoiceSelfPricing = "sales_invoice_self_pricing" as const;
/** 1.2 Τιμολόγιο Πώλησης / Ενδοκοινοτικές Παραδόσεις */
export const salesInvoiceEU = "sales_invoice_eu";
/** 1.3 Τιμολόγιο Πώλησης / Παραδόσεις Τρίτων Χωρών */
export const salesInvoiceNonEU = "sales_invoice_non_eu";
/** 1.4 Τιμολόγιο Πώλησης / Πώληση για Λογαριασμό Τρίτων */
export const salesInvoiceThirdParty = "sales_invoice_third_party";
/** 1.5 Τιμολόγιο Πώλησης / Εκκαθάριση Πωλήσεων Τρίτων / Αμοιβή από Πωλήσεις Τρίτων  */
export const settlementInvoice = "settlement_invoice";
/** 1.6 Τιμολόγιο Πώλησης / Συμπληρωματικό Παραστατικό */
export const salesInvoiceAdditional = "sales_invoice_additional";

/** 2.1 Τιμολόγιο Παροχής Υπηρεσιών */
export const servicesInvoice = "services_invoice";
/** 2.2 Τιμολόγιο Παροχής / Ενδοκοινοτική Παροχή Υπηρεσιών */
export const servicesInvoiceEU = "services_invoice_eu";
/** 2.3 Τιμολόγιο Παροχής / Παροχή Υπηρεσιών σε λήπτη Τρίτης Χώρας */
export const servicesInvoiceNonEU = "services_invoice_non_eu";
/** 2.4 Τιμολόγιο Παροχής Υπηρεσιών / Συμπληρωματικό Παραστατικό */
export const servicesInvoiceAdditional = "services_invoice_additional";

/** 3.1 Τίτλος Κτήσης Μη Υπόχρεος Εκδότης */
export const acquisitionTitleUnobligatedIssuer =
  "acquisition_title_unobligated_issuer";
/** 3.2 Τίτλος Κτήσης Άρνηση Έκδοσης από Υπόχρεο Εκδότη */
export const acquisitionTitleIssueRefusal = "acquisition_title_issue_refusal";

/**
 * Πιστωτικά Τιμολόγια
 *
 * @see https://www.e-forologia.gr/cms/viewContents.aspx?id=219684
 *
 * 24. Ποια η διαφορά του Τύπου Παραστατικού
 *     5.1 Πιστωτικό Τιμολόγιο / Συσχετιζόμενο
 *     και του 5.2 Πιστωτικό Τιμολόγιο / Μη Συσχετιζόμενο;
 *
 * Ο Τύπος Παραστατικού 5.1 περιλαμβάνει περιπτώσεις πιστωτικών που
 * συσχετίζονται με προηγούμενο τιμολόγιο και περιλαμβάνει όλες τις περιπτώσεις
 * παραστατικών εσόδων ημεδαπής και αλλοδαπής (ενδοκοινοτικές, τρίτων χωρών).
 * Σε κάθε περίπτωση είναι υποχρεωτική η αναγραφή του συσχετιζόμενου ΜΑΡΚ
 * του αρχικού παραστατικού.
 *
 * Ο Τύπος Παραστατικού 5.2 περιλαμβάνει είτε περιπτώσεις πιστωτικών τζίρου
 * που δεν σχετίζονται άμεσα με συγκεκριμένα παραστατικά
 * που έχουν εκδοθεί προγενέστερα,
 * είτε περιπτώσεις πιστωτικών που μπορεί να συσχετίζονται με παραστατικά
 * που έχουν εκδοθεί προγενέστερα αλλά δεν επιλέγεται από την επιχείρηση
 * ο άμεσος συσχετισμός τους. Επίσης περιλαμβάνει όλες τις περιπτώσεις
 * παραστατικών εσόδων ημεδαπής και αλλοδαπής (ενδοκοινοτικές, τρίτων χωρών).
 */

/** 5.1 Πιστωτικό Τιμολόγιο Συσχετιζόμενο */
export const creditInvoiceCorrelated = "credit_invoice_correlated";
/** 5.2 Πιστωτικό Τιμολόγιο Μή Συσχετιζόμενο */
export const creditInvoiceNonCorrelated = "credit_invoice_non_correlated";

/** 6.1 Στοιχείο Αυτοπαράδοσης */
export const selfDeliveryInvoice = "self_delivery_invoice";

/** 6.2 Στοιχείο Ιδιοχρησιμοποίησης */
export const selfConsumptionInvoice = "self_consumption_invoice";

/** 7.1 Συμβόλαιο Έσοδο */
export const contractIncome = "contract_income";

/** 8.1 Ενοίκια - Έσοδο */
export const rentReceipt = "rent_receipt";
/** 8.2 Ειδικό Στοιχείο - Απόδειξης Είσπραξης Φόρου Διαμονής */
export const accomodationTaxReceipt = "accommodation_tax_receipt";

/** 8.4 Απόδειξη Είσπραξης POS */
export const posReceipt = "pos_receipt";

/** 11.1 Απόδειξη Λιανικής Πώλησης */
export const retailSalesReceipt = "retail_sales_receipt";
/** 11.2 Απόδειξη Παροχής Υπηρεσιών */
export const retailServicesReceipt = "retail_services_receipt";
/** 11.3 Απλοποιημένο Τιμολόγιο */
export const retailSimpleInvoice = "retail_simple_invoice";
/** 11.4 Πιστωτικό Στοιχείο Λιανικής */
export const retailCreditElement = "retail_credit_element";
/** 11.5 Απόδειξη Λιανικής Πώλησης για Λογαριασμό Τρίτων */
export const retailThirdPartySalesReceipt = "retail_third_party_sales_receipt";

/**
 * All invoice types
 *
 * Not all of them are supported for invoice creation.
 * @see supportedInvoiceTypes
 */
export const invoiceTypes = [
  salesInvoice,
  salesInvoiceSelfPricing,
  salesInvoiceEU,
  salesInvoiceNonEU,
  salesInvoiceThirdParty,
  settlementInvoice,
  salesInvoiceAdditional,

  servicesInvoice,
  servicesInvoiceEU,
  servicesInvoiceNonEU,
  servicesInvoiceAdditional,

  acquisitionTitleUnobligatedIssuer,
  acquisitionTitleIssueRefusal,

  creditInvoiceCorrelated,
  creditInvoiceNonCorrelated,

  selfDeliveryInvoice,
  selfConsumptionInvoice,

  contractIncome,

  rentReceipt,
  accomodationTaxReceipt,

  retailSalesReceipt,
  retailServicesReceipt,
  retailSimpleInvoice,
  retailThirdPartySalesReceipt,
  retailCreditElement,
  posReceipt,
] as const;

export type InvoiceType = typeof invoiceTypes[number];

export const invoiceMeta = {
  [salesInvoice]: {
    code: "1.1",
    name: "Τιμολόγιο Πώλησης",
    dispatch: true,
    classifications: {
      [saleOfMerchandise]: [E3_561_001, E3_561_002, E3_561_007],
      [saleOfProducts]: [E3_561_001, E3_561_002, E3_561_007],
      [saleOfServices]: [E3_561_001, E3_561_007, E3_563],
      [saleOfAsset]: [E3_880_001],
      [otherIncome]: [
        E3_561_007,
        E3_562,
        E3_563,
        E3_564,
        E3_565,
        E3_566,
        E3_568,
        E3_570,
        E3_561_002,
      ],
    },
  },
  [salesInvoiceSelfPricing]: {
    code: "1.1",
    name: "Τιμολόγιο Πώλησης / Αυτοτιμολόγηση",
    dispatch: true,
    selfPricing: true,
    classifications: {
      [saleOfServices]: [E3_561_001, E3_561_007, E3_563],
    },
  },
  [salesInvoiceEU]: {
    code: "1.2",
    name: "Τιμολόγιο Πώλησης / Ενδοκοινοτικές Παραδόσεις",
    dispatch: true,
    recipientCountries: foreignCountryEU,
    classifications: undefined,
  },
  [salesInvoiceNonEU]: {
    code: "1.3",
    name: "Τιμολόγιο Πώλησης / Παραδόσεις Τρίτων Χωρών",
    dispatch: true,
    recipientCountries: foreignCountryNonEU,
    classifications: undefined,
  },
  [salesInvoiceThirdParty]: {
    code: "1.4",
    name: "Τιμολόγιο Πώλησης για Λογαριασμό Τρίτων",
    thirdParty: true,
    dispatch: true,
    classifications: undefined,
  },
  [settlementInvoice]: {
    code: "1.5",
    name: "Τιμολόγιο Πώλησης / Εκκαθάριση / Αμοιβή από Πωλήσεις Τρίτων ",
    classifications: undefined,
  },
  [salesInvoiceAdditional]: {
    code: "1.6",
    name: "Τιμολόγιο Πώλησης / Συμπληρωματικό Παραστατικό",
    correlated: [
      salesInvoice,
      salesInvoiceEU,
      salesInvoiceNonEU,
      salesInvoiceThirdParty,
      settlementInvoice,
    ],
    classifications: undefined,
  },
  [servicesInvoice]: {
    code: "2.1",
    name: "Τιμολόγιο Παροχής Υπηρεσιών",
    selfPricing: true,
    classifications: undefined,
  },
  [servicesInvoiceEU]: {
    code: "2.2",
    name: "Τιμολόγιο Παροχής / Ενδοκοινοτική Παροχή Υπηρεσιών",
    recipientCountries: foreignCountryEU,
    classifications: undefined,
  },
  [servicesInvoiceNonEU]: {
    code: "2.3",
    name: "Τιμολόγιο Παροχής / Παροχή Υπηρεσιών σε λήπτη Τρίτης Χώρας",
    recipientCountries: foreignCountryNonEU,
    classifications: undefined,
  },
  [servicesInvoiceAdditional]: {
    code: "2.4",
    name: "Τιμολόγιο Παροχής Υπηρεσιών / Συμπληρωματικό Παραστατικό",
    correlated: [servicesInvoice, servicesInvoiceEU, servicesInvoiceNonEU],
    classifications: undefined,
  },
  [acquisitionTitleUnobligatedIssuer]: {
    code: "3.1",
    name: "Τίτλος Κτήσης / Μη Υπόχρεος Εκδότης",
    classifications: undefined,
  },
  [acquisitionTitleIssueRefusal]: {
    code: "3.2",
    name: "Τίτλος Κτήσης / Άρνηση Έκδοσης από Υπόχρεο Εκδότη",
    classifications: undefined,
  },
  [creditInvoiceCorrelated]: {
    code: "5.1",
    name: "Πιστωτικό Τιμολόγιο Συσχετιζόμενο",
    correlated: [
      salesInvoice,
      salesInvoiceEU,
      salesInvoiceNonEU,
      salesInvoiceThirdParty,
      settlementInvoice,
      servicesInvoice,
      servicesInvoiceEU,
      servicesInvoiceNonEU,
    ],
    classifications: undefined,
  },
  [creditInvoiceNonCorrelated]: {
    code: "5.2",
    name: "Πιστωτικό Τιμολόγιο Μή Συσχετιζόμενο",
    receipientCountries: anyCountry,
    classifications: undefined,
  },
  [selfDeliveryInvoice]: {
    code: "6.1",
    name: "Στοιχείο Αυτοπαράδοσης",
    dispatch: true,
    classifications: undefined,
  },
  [selfConsumptionInvoice]: {
    code: "6.2",
    name: "Στοιχείο Ιδιοχρησιμοποίησης",
    classifications: undefined,
  },
  [contractIncome]: {
    code: "7.1",
    name: "Συμβόλαιο Έσοδο",
    classifications: undefined,
  },
  [rentReceipt]: {
    code: "8.1",
    name: "Ενοίκια - Έσοδο",
    classifications: undefined,
  },
  [accomodationTaxReceipt]: {
    code: "8.2",
    name: "Ειδικό Στοιχείο - Απόδειξης Είσπραξης Φόρου Διαμονής",
    classifications: undefined,
  },
  [posReceipt]: {
    code: "8.4",
    name: "Απόδειξη Είσπραξης POS",
    dispatch: true,
    classifications: {
      [saleOfMerchandise]: [E3_561_001, E3_561_002, E3_561_007],
      [saleOfProducts]: [E3_561_001, E3_561_002, E3_561_007],
      [saleOfServices]: [E3_561_001, E3_561_002, E3_561_007, E3_563],
      [saleOfAsset]: [E3_880_001],
      [otherIncome]: [
        E3_561_002,
        E3_561_007,
        E3_562,
        E3_563,
        E3_564,
        E3_565,
        E3_566,
        E3_567,
        E3_568,
        E3_570
      ],
      [incomeThirdParty]: [E3_881_001, E3_881_003, E3_881_004]
    }
  },
  [retailSalesReceipt]: {
    code: "11.1",
    name: "Απόδειξη Λιανικής Πώλησης",
    classifications: undefined,
  },
  [retailServicesReceipt]: {
    code: "11.2",
    name: "Απόδειξη Παροχής Υπηρεσιών",
    classifications: undefined,
  },
  [retailSimpleInvoice]: {
    code: "11.3",
    name: "Απλοποιημένο Τιμολόγιο",
    classifications: undefined,
  },
  [retailCreditElement]: {
    code: "11.4",
    name: "Πιστωτικό Στοιχείο Λιανικής",
    credit: true,
    classifications: undefined,
  },
  [retailThirdPartySalesReceipt]: {
    code: "11.5",
    name: "Απόδειξη Λιανικής Πώλησης για Λογαριασμό Τρίτων",
    thirdParty: true,
    classifications: undefined,
  },
} as const;

export type InvoiceMeta = typeof invoiceMeta;
expectAssignable<ReadonlyDeep<Record<InvoiceType, InvoiceSpec>>>(invoiceMeta);

export const isInvoiceType = (input: unknown): input is InvoiceType =>
  typeof input === "string" && Object.keys(invoiceMeta).includes(input);

export const invoiceRegion = ["GR", "EU", "NonEU"] as const;

type InvoiceCategory = {
  [T in InvoiceTypeMyData]: T extends `${infer C}.${infer _}` ? C : never;
}[InvoiceTypeMyData];

type InvoiceTypeCategory<C extends InvoiceCategory> = {
  [T in keyof InvoiceMeta]: InvoiceMeta[T]["code"] extends `${C}.${infer _}`
    ? T
    : never;
}[InvoiceType];
const invoiceCategoryTypeGuard =
  <C extends InvoiceCategory>(category: C) =>
  (input: unknown): input is InvoiceTypeCategory<C> =>
    isInvoiceType(input) && invoiceMeta[input].code.startsWith(category);

export type SalesInvoiceType = InvoiceTypeCategory<"1">;
export const isSalesInvoiceType = invoiceCategoryTypeGuard("1");
export type ServicesInvoiceType = InvoiceTypeCategory<"2">;
export const isServicesInvoiceType = invoiceCategoryTypeGuard("2");
export type RetailInvoiceType = InvoiceTypeCategory<"11">;
export const isRetailInvoiceType = invoiceCategoryTypeGuard("11");
export type InvoiceEU = typeof salesInvoiceEU | typeof servicesInvoiceEU;
export const isInvoiceEU = (input?: InvoiceType): input is InvoiceEU =>
  input === servicesInvoiceEU || input === salesInvoiceEU;
export type InvoiceNonEU =
  | typeof salesInvoiceNonEU
  | typeof servicesInvoiceNonEU;
export const isInvoiceNonEU = (input?: InvoiceType): input is InvoiceNonEU =>
  input === servicesInvoiceNonEU || input === salesInvoiceNonEU;
export type InvoiceGR = Exclude<InvoiceType, InvoiceEU | InvoiceNonEU>;
export const isInvoiceGR = (input?: InvoiceType): input is InvoiceGR =>
  isInvoiceEU(input) === isInvoiceNonEU(input); // only true when both false

export const isInvoicePosReceipt = (input?: InvoiceType): boolean =>
  input === posReceipt;

export type InvoiceFacing = Exclude<InvoiceType, RetailInvoiceType>;
export const isInvoiceFacing = (input?: InvoiceType): input is InvoiceFacing =>
  !isRetailInvoiceType(input);

export const invoiceCode = (t: InvoiceType): InvoiceTypeMyData =>
  invoiceMeta[t].code;

export type InvoiceSpec = {
  code: InvoiceTypeMyData;
  name: string;
  dispatch?: boolean;
  thirdParty?: boolean;
  retail?: boolean;
  credit?: boolean;
  selfPricing?: boolean;
  correlated?: InvoiceType[];
  recipientCountries?: Country[];
  classifications?: Partial<
    Record<ClassificationCategory, ClassificationType[]>
  >;
};

export const invoiceSpec = (typ: InvoiceType) => invoiceMeta[typ];
